import React from 'react';
import { ShieldCheckIcon, CheckCircleIcon } from 'lucide-react';
import { scrollToOffer } from '../utils/scroll';
export function GuaranteeSection() {
  const points = ['Nessun rischio per te', 'Rimborso completo del 100%', 'Senza fare domande', 'Procedura semplice via email'];
  return <section className="py-16 px-4 bg-gray-50" data-id="element-100">
      <div className="max-w-4xl mx-auto bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-gray-100 relative overflow-hidden" data-id="element-101">
        {/* Decorative background elements */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-blue-50 rounded-full blur-3xl -mr-20 -mt-20 opacity-50" data-id="element-102"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-green-50 rounded-full blur-3xl -ml-20 -mb-20 opacity-50" data-id="element-103"></div>

        <div className="relative z-10 flex flex-col md:flex-row items-center gap-10" data-id="element-104">
          {/* Visual Seal */}
          <div className="w-full md:w-1/3 flex justify-center" data-id="element-105">
            <div className="relative w-48 h-48 flex items-center justify-center" data-id="element-106">
              {/* Outer dashed ring */}
              <div className="absolute inset-0 border-4 border-dashed border-blue-200 rounded-full animate-[spin_20s_linear_infinite]" data-id="element-107"></div>
              {/* Inner solid ring */}
              <div className="absolute inset-2 bg-gradient-to-br from-blue-600 to-blue-800 rounded-full shadow-lg flex flex-col items-center justify-center text-white p-4 text-center border-4 border-white" data-id="element-108">
                <ShieldCheckIcon className="w-10 h-10 mb-1 text-blue-200" data-id="element-109" />
                <span className="text-3xl font-black leading-none tracking-tighter" data-id="element-110">
                  45
                </span>
                <span className="text-sm font-bold tracking-widest uppercase" data-id="element-111">
                  Giorni
                </span>
                <span className="text-[10px] uppercase tracking-wider mt-1 opacity-80" data-id="element-112">
                  Garanzia
                </span>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="w-full md:w-2/3 text-center md:text-left" data-id="element-113">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-114">
              Garanzia di Soddisfazione 100%
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed" data-id="element-115">
              Puoi provare il Mega-Pack senza alcun rischio. Hai{' '}
              <strong data-id="element-116">45 giorni</strong> di tempo per testare i materiali nelle
              tue classi. Se per qualsiasi motivo non sei soddisfatto dei
              risultati, ti restituiremo ogni centesimo.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8" data-id="element-117">
              {points.map((point, idx) => <div key={idx} className="flex items-center gap-2 text-gray-800 font-medium" data-id="element-118">
                  <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-119" />
                  <span data-id="element-120">{point}</span>
                </div>)}
            </div>

            <button onClick={scrollToOffer} className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 px-8 rounded-xl shadow-lg transform hover:-translate-y-1 transition-all duration-300" data-id="element-121">
              Prova senza rischi
            </button>
          </div>
        </div>
      </div>
    </section>;
}